module.exports = __webpack_public_path__ + "static/FigmaLogo-2e2e83e9f734ae242fab74edd9742971.svg";